import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  actionLabel?: string;
  actionTo?: string;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  desc,
  action,
  actionLabel,
  actionTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200">
        <i className={`${icon} text-2xl text-foreground-500`} />
      </span>
      <h3 className="mt-4 text-base font-semibold text-foreground-900">{title}</h3>
      {desc && <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{desc}</p>}
      <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
        {action}
        {actionTo && actionLabel && (
          <Link
            to={actionTo}
            className="inline-flex cursor-pointer items-center gap-1 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            {actionLabel}
            <i className="ri-arrow-right-line text-sm" />
          </Link>
        )}
      </div>
    </div>
  );
}